import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, ArrowRightIcon, LockIcon, DownloadIcon, CreditCardIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function PricingSection() {
  return <section id="pricing" className="py-20 bg-white md:py-32" data-id="element-89">
      <div className="px-4 mx-auto max-w-4xl sm:px-6 lg:px-8" data-id="element-90">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="max-w-2xl mx-auto overflow-hidden shadow-xl bg-white rounded-3xl border border-sage-light/40" data-id="element-91">
          {/* Top Section: Value Breakdown */}
          <div className="p-8 md:p-12 bg-white text-center" data-id="element-92">
            <motion.div variants={itemVariants} className="mb-8" data-id="element-93">
              <span className="inline-block px-4 py-1.5 text-xs font-bold tracking-wider text-white uppercase rounded-full bg-warm-green" data-id="element-94">
                OFERTA ESPECIAL HOY
              </span>
            </motion.div>

            <motion.div variants={itemVariants} className="flex justify-center mb-10" data-id="element-95">
              <img src="https://cdn.magicpatterns.com/uploads/soLyyRnoH2A7SVvxGV6L4d/Gemini_Generated_Image_8p3hl08p3hl08p3h_(1)_cleanup.png" alt="Ebook Organiza Tu Vida en 10 Minutos al Día + 5 Bonos de Regalo" className="w-full max-w-md rounded-2xl shadow-lg" data-id="element-96" />
            </motion.div>

            <motion.ul variants={containerVariants} className="max-w-md mx-auto mb-8 space-y-3 text-lg text-charcoal/80 text-left" data-id="element-97">
              {[{
              name: 'Ebook principal',
              price: '$27'
            }, {
              name: 'Bono 1',
              price: '$47'
            }, {
              name: 'Bono 2',
              price: '$37'
            }, {
              name: 'Bono 3',
              price: '$27'
            }, {
              name: 'Bono 4',
              price: '$27'
            }, {
              name: 'Bono 5',
              price: '$47'
            }].map((item, index) => <motion.li key={index} variants={itemVariants} className="flex justify-between border-b border-sage-light/20 pb-2" data-id="element-98">
                  <span data-id="element-99">{item.name}</span>
                  <span className="font-medium" data-id="element-100">{item.price}</span>
                </motion.li>)}
              <motion.li variants={itemVariants} className="flex justify-between pt-3 text-xl font-bold text-charcoal" data-id="element-101">
                <span data-id="element-102">Todo este sistema tiene un valor real de</span>
                <span data-id="element-103">$212</span>
              </motion.li>
            </motion.ul>

            <motion.div variants={itemVariants} className="mb-6" data-id="element-104">
              <p className="text-lg font-medium text-charcoal/50 line-through" data-id="element-105">
                Pero hoy no pagarás $212
              </p>
              <p className="text-lg font-medium text-charcoal/50 line-through" data-id="element-106">
                Ni siquiera pagarás $97
              </p>
            </motion.div>
          </div>

          {/* Visual Divider */}
          <div className="border-t border-sage-light/40" data-id="element-107"></div>

          {/* Lo Que Obtienes Hoy Section */}
          <div className="p-8 md:p-12 bg-beige-warm text-left border-b border-sage-light/40" data-id="element-108">
            <motion.div variants={itemVariants} className="max-w-md mx-auto" data-id="element-109">
              <h4 className="mb-6 text-xl font-bold text-charcoal font-playfair text-center" data-id="element-110">
                Hoy recibirás acceso inmediato a:
              </h4>
              <ul className="space-y-3 text-lg text-charcoal/90 font-medium" data-id="element-111">
                <li className="flex items-center" data-id="element-112">
                  <div className="w-2 h-2 rounded-full bg-sage mr-3 shrink-0" data-id="element-113"></div>
                  Ebook principal
                </li>
                <li className="flex items-center" data-id="element-114">
                  <div className="w-2 h-2 rounded-full bg-sage mr-3 shrink-0" data-id="element-115"></div>
                  Bono 1
                </li>
                <li className="flex items-center" data-id="element-116">
                  <div className="w-2 h-2 rounded-full bg-sage mr-3 shrink-0" data-id="element-117"></div>
                  Bono 2
                </li>
                <li className="flex items-center" data-id="element-118">
                  <div className="w-2 h-2 rounded-full bg-sage mr-3 shrink-0" data-id="element-119"></div>
                  Bono 3
                </li>
                <li className="flex items-center" data-id="element-120">
                  <div className="w-2 h-2 rounded-full bg-sage mr-3 shrink-0" data-id="element-121"></div>
                  Bono 4
                </li>
                <li className="flex items-center" data-id="element-122">
                  <div className="w-2 h-2 rounded-full bg-sage mr-3 shrink-0" data-id="element-123"></div>
                  Bono 5
                </li>
              </ul>
            </motion.div>
          </div>

          {/* Middle Section: Final Price */}
          <div className="p-8 md:p-12 bg-sage text-white text-center" data-id="element-124">
            <motion.div variants={itemVariants} data-id="element-125">
              <p className="mb-6 text-sm font-bold tracking-wider uppercase text-white" data-id="element-126">
                HOY PUEDES OBTENER TODO POR SOLO
              </p>

              <div className="mb-6 text-8xl md:text-9xl font-extrabold text-white font-playfair drop-shadow-lg leading-none" data-id="element-127">
                $17
              </div>

              <div className="inline-block px-6 py-2 font-semibold rounded-full bg-white/20 text-white" data-id="element-128">
                Ahorras $195 hoy
              </div>
            </motion.div>
          </div>

          {/* Bottom Section: CTA & Trust */}
          <div className="p-8 md:p-12 bg-beige-warm text-center" data-id="element-129">
            <motion.div variants={itemVariants} data-id="element-130">
              <motion.a href="#" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} animate={{
              boxShadow: ['0 0 0 0 rgba(247, 243, 238, 0.4)', '0 0 0 12px rgba(247, 243, 238, 0)', '0 0 0 0 rgba(247, 243, 238, 0)']
            }} transition={{
              boxShadow: {
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }
            }} className="inline-flex items-center justify-center w-full px-10 py-5 mb-8 text-lg font-bold text-white transition-all rounded-full sm:w-auto bg-sage hover:bg-sage-dark shadow-xl shadow-sage/30 hover:shadow-sage/50" data-id="element-131">
                QUIERO ORGANIZAR MI VIDA AHORA
                <motion.span animate={{
                x: [0, 5, 0]
              }} transition={{
                duration: 1.2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-132">
                  <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-133" />
                </motion.span>
              </motion.a>

              <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm font-medium text-charcoal/60" data-id="element-134">
                <div className="flex items-center" data-id="element-135">
                  <LockIcon className="w-4 h-4 mr-2" data-id="element-136" />
                  <span data-id="element-137">Pago seguro</span>
                </div>
                <div className="flex items-center" data-id="element-138">
                  <DownloadIcon className="w-4 h-4 mr-2" data-id="element-139" />
                  <span data-id="element-140">Descarga inmediata</span>
                </div>
                <div className="flex items-center" data-id="element-141">
                  <CreditCardIcon className="w-4 h-4 mr-2" data-id="element-142" />
                  <span data-id="element-143">Pago único — sin suscripción</span>
                </div>
              </div>

              <p className="mb-6 text-lg italic text-charcoal/70 font-playfair" data-id="element-144">
                Empieza hoy a organizar tu vida en solo 10 minutos al día.
              </p>

              <div className="flex items-center justify-center text-sm font-medium text-charcoal/50" data-id="element-145">
                <ShieldIcon className="w-4 h-4 mr-2 text-warm-green" data-id="element-146" />
                <span data-id="element-147">Compra segura</span>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} className="flex flex-col items-center max-w-2xl p-8 mx-auto mt-12 text-center bg-white border border-beige shadow-sm rounded-2xl md:flex-row md:text-left" data-id="element-148">
          <div className="flex items-center justify-center flex-shrink-0 w-16 h-16 mb-6 rounded-full bg-warm-green/10 md:mb-0 md:mr-6" data-id="element-149">
            <ShieldIcon className="w-8 h-8 text-warm-green" data-id="element-150" />
          </div>
          <div data-id="element-151">
            <h4 className="mb-2 text-xl font-bold text-charcoal font-playfair" data-id="element-152">
              Garantía de 7 Días
            </h4>
            <p className="text-charcoal/80" data-id="element-153">
              Si lees el ebook y no sientes que te ayuda a tener más claridad y
              control sobre tu vida, simplemente pide tu reembolso dentro de los
              primeros 7 días. <span className="font-bold" data-id="element-154">Sin preguntas.</span>
            </p>
          </div>
        </motion.div>

        {/* Final CTA */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="max-w-3xl mx-auto mt-24 text-center" data-id="element-155">
          <motion.h2 variants={itemVariants} className="mb-10 text-3xl font-bold md:text-4xl text-charcoal font-playfair leading-tight" data-id="element-156">
            Si eres una mamá ocupada que quiere recuperar el control de su
            tiempo y su mente… <br data-id="element-157" />
            <span className="text-sage" data-id="element-158">
              Este sistema fue creado exactamente para ti.
            </span>
          </motion.h2>

          <motion.div variants={itemVariants} data-id="element-159">
            <motion.a href="#" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(139, 168, 137, 0.4)', '0 0 0 12px rgba(139, 168, 137, 0)', '0 0 0 0 rgba(139, 168, 137, 0)']
          }} transition={{
            boxShadow: {
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }
          }} className="inline-flex items-center justify-center w-full px-8 py-5 mb-8 text-lg font-bold text-white transition-all rounded-full sm:w-auto bg-sage hover:bg-sage-dark shadow-xl shadow-sage/30 hover:shadow-sage/50" data-id="element-160">
              QUIERO EMPEZAR MI SISTEMA DE 30 DÍAS
              <motion.span animate={{
              x: [0, 5, 0]
            }} transition={{
              duration: 1.2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-161">
                <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-162" />
              </motion.span>
            </motion.a>
          </motion.div>

          <motion.p variants={itemVariants} className="text-xl font-medium text-charcoal/70 font-playfair italic" data-id="element-163">
            "No necesitas más horas en el día. <br className="md:hidden" data-id="element-164" />
            Solo necesitas un sistema que funcione incluso cuando estás
            cansada."
          </motion.p>
        </motion.div>
      </div>
    </section>;
}